import { useSellarDistributionAvailabilityList } from "../../../../hooks/api/v2/sellarDistributionAvailability/useSellarDistributionAvailabilityList";
import { useStorefrontBuyerPostcode } from "../../../stockList/categoryPage/Storefront/lib/useStorefrontBuyerPostcode";

export const useCanShowDeliveredBySellarOptionV2 = () => {
  const { buyerPostcode } = useStorefrontBuyerPostcode();
  const sellarDistributionAvailabilityListQuery =
    useSellarDistributionAvailabilityList(
      {
        query: [
          {
            type: "retailerPostcode",
            modifier: "EQUALS",
            value: buyerPostcode,
          },
        ],
        limit: 1,
      },
      {
        enabled: !!buyerPostcode,
      },
    );

  const sellarDistributionAvailability =
    sellarDistributionAvailabilityListQuery.data?.pages.flat() ?? [];

  return sellarDistributionAvailability.length > 0;
};
